<div id="dark" class="page-background">
  <div class="settings dark-bb " style="margin-top: 115px; min-height: 100vh">
    <div class="container-fluid">
      <div class="row">

        <div class="col-md-12 col-lg-2">
          <div class="row p-1 mb-1 hello-card" style="border-radius: 15px;">
            <h6 class="text-color-theme text-center m-1">{{'hello'|translate}} {{userName}}</h6>
            <button type="button" class="btn btn-default btn-circle shadow-none" (click)="fetchUserPortfolio()">
              <i class="fas fa-refresh" *ngIf="!isProfileLoading"></i>
              <span *ngIf="isProfileLoading" class="spinner-border spinner-border-sm"></span>
            </button>
          </div>

          <div class="nav flex-column nav-pills settings-nav" id="v-pills-tab" role="tablist"
            aria-orientation="vertical">
            <a class="nav-link" id="settings-profile-tab" data-toggle="pill" href="#settings-profile" role="tab"
            (click)="hideTradesSummary()" aria-controls="settings-profile" aria-selected="true"><i class="icon ion-md-person px-2"></i>
              {{"profile"|translate}}</a>
            <a class="nav-link active" id="portfolio-tab" data-toggle="pill" href="#portfolio"
              (click)="fetchUserPortfolio()" role="tab" aria-controls="portfolio" aria-selected="false"><i
                class="icon ion-md-wallet px-2"></i>
              {{"portfolio"|translate}}</a>
            <!-- <a class="nav-link" id="action-tab" data-toggle="pill" href="#actions" role="tab" 
            (click)="hideTradesSummary()" aria-selected="false"><i
                class="icon ion-md-information-circle px-2"></i> {{"actions"|translate}}</a> -->
            <a class="nav-link" id="action-tab" data-toggle="pill" href="#transfers" role="tab" 
            (click)="hideTradesSummary()" aria-selected="false"><i
                class="icon ion-md-information-circle px-2"></i>
              {{"transfer"|translate}}</a>
          </div>
          <div class="card mt-2" style="border-radius: 15px;">
            <small class="text-color-theme text-center m-1">
              {{'last-login'|translate}}
              {{lastLogin | date:'d/M/yy, h:mm a'}}
            </small>
          </div>
          <br>
          <user-trades-summary *ngIf="showTradesSummary" [acc]="selectedAccount"></user-trades-summary>

        </div>

        <div class="col-md-12 col-lg-10">
          <div class="tab-content" id="v-pills-tabContent">
            <div class="tab-pane fade  mt-xl-auto mt-lg-auto mt-3" id="settings-profile" role="tabpanel" aria-labelledby="settings-profile-tab">
              <div class="card">
                <section class="example-section" *ngIf="!userPortfolio">
                  <mat-progress-bar class="example-margin" [color]="'primary'" [mode]="'indeterminate'" [value]="50"
                    [bufferValue]="75">
                  </mat-progress-bar>
                </section>

                <div class="card-body">
                  <div>
                    <app-account-header (accChange)="fetchUserPortfolio($event)" [accList]="accList"
                      [selectedAccount]="selectedAccount"></app-account-header>
                  </div>
                  <div class="row settings-notification align-items-center mt-4">
                    <div class="col-md-6 text-color-theme vl px-5 ">
                      <div class="mb-3 d-flex justify-content-between align-items-center">
                        <div>
                          <h6 class="profile-heading">{{"phone"|translate}}</h6>
                        </div>
                        <div class="d-flex align-items-center" style="gap: 12px;">
                          <button
                            *ngIf="userPortfolio?.Profile?.MobileNumbers && userPortfolio?.Profile?.MobileNumbers?.length > 1"
                            [ngbPopover]="mobilePopoverTemplateScreen"
                            popoverTitle=""
                            placement="bottom"
                            container="body"
                            popoverClass="mobile-custom-popover"
                            class="btn btn-outline-theme btn-sm text-highlight-company-color me-2 d-inline-flex align-items-center"
                            style="border: 1px solid var(--highlight-company-color, #16a085) !important; color: #ffffff !important; background: transparent; border-radius: 4px; padding: 2px 10px; font-size: 0.8rem; height: 26px; cursor: pointer; gap: 8px;"
                          >
                            <span style="color: #ffffff !important;">{{ 'viewMore' | translate }}</span>
                            <mat-icon style="font-size: 1.1rem; height: 1.1rem; width: 1.1rem; line-height: 1.1rem; vertical-align: middle; color: var(--highlight-company-color, #16a085);">arrow_drop_down_circle</mat-icon>
                          </button>
                          <h6 class="mb-0" dir="ltr" style="unicode-bidi: embed; display: inline-block;">
                            {{userPortfolio?.Profile?.Phone}}
                          </h6>
                          <ng-template #mobilePopoverTemplateScreen>
                            <div class="mobile-popover-card">
                              <div class="popover-header-title">
                                {{ 'contacts' | translate }}
                              </div>
                              <div class="popover-content-body">
                                <div class="popover-inner-box">
                                  <div *ngFor="let mob of userPortfolio?.Profile?.MobileNumbers; let last = last"
                                       class="d-flex justify-content-between align-items-center"
                                       [class.mobile-item-divider]="!last"
                                       [style.margin-bottom]="last ? '0px' : '8px'"
                                       [style.padding-bottom]="last ? '0px' : '6px'">
                                    <span dir="ltr" class="mobile-number-text" style="unicode-bidi: embed;">{{ mob }}</span>
                                    <mat-icon style="font-size: 1.1rem; height: 1.1rem; width: 1.1rem; line-height: 1.1rem; color: var(--highlight-company-color, #16a085);">phone_iphone</mat-icon>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                        </div>
                      </div>
                      <div class="mb-3 d-flex justify-content-between">
                        <div>
                          <h6 class="profile-heading">{{"email"|translate}}</h6>
                        </div>
                        <div>
                          <h6>
                            {{userPortfolio?.Profile.Email}}
                          </h6>
                        </div>
                      </div>
                      <div class="mb-3 d-flex justify-content-between">
                        <div>
                          <h6 class="profile-heading">{{"nationalID"|translate}}</h6>
                        </div>
                        <div>
                          <h6>
                            {{userPortfolio?.Profile.IdNumber}}
                          </h6>
                        </div>
                      </div>
                      <div class="mb-3 d-flex justify-content-between">
                        <div>
                          <h6 class="profile-heading">{{"company-name"|translate}}</h6>
                        </div>
                        <div>
                          <h6>
                            {{ translate.currentLang == 'en'
                            ? userPortfolio?.Profile?.CompanyNameEn 
                            : userPortfolio?.Profile?.CompanyNameAr 
                         }}
                          </h6>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 text-color-theme px-5">
                      <div class="mb-3 d-flex justify-content-between">
                        <div>
                          <h6 class="profile-heading">{{"address"|translate}}</h6>
                        </div>
                        <div>
                          <h6>
                            {{userPortfolio?.Profile.Address}}
                          </h6>
                        </div>
                      </div>
                      <div class="mb-3 d-flex justify-content-between">
                        <div>
                          <h6 class="profile-heading">{{"acc-mgr"|translate}}</h6>
                        </div>
                        <div>
                          <h6>
                            {{userPortfolio?.Profile.AccountManagerNameE}}
                          </h6>
                        </div>
                      </div>
                      <div class="mb-3 d-flex justify-content-between">
                        <div>
                          <h6 class="profile-heading">{{"branch"|translate}}</h6>
                        </div>
                        <div>
                          <h6>
                            {{userPortfolio?.Profile.BranchNameE}}
                          </h6>
                        </div>
                      </div>
                      <div class="mb-3 d-flex justify-content-between">
                        <div>
                          <h6 class="profile-heading">{{"market-manager"|translate}}</h6>
                        </div>
                        <div>
                          <h6>
                            {{ translate.currentLang == 'en' 
                            ? (userPortfolio?.Profile?.RelationShipNameEn || ("not-assigned" | translate)) 
                            : (userPortfolio?.Profile?.RelationShipNameAr || ("not-assigned" | translate)) 
                        }}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="p-1 mt-3 mx-2 d-flex justify-content-center">
                    <a [routerLink]="['/changePassword']" [queryParams]="{relationCode:selectedAccount}" class="rounded-pill">{{'change-password'| translate}}</a>
                  </div> -->
                </div>

              </div>
              <div class="d-flex flex-xl-row flex-lg-row flex-md-row flex-sm-row flex-column">
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 p-1">
                  <div class=" card h-100">
                    <div class="card-body p-5 text-color-theme text-center">
                      <div class="mx-auto" *ngIf="chartOptions?.chart?.type != null && !noChart">
                        <apx-chart [series]="chartOptions?.series" [chart]="chartOptions?.chart"
                          [labels]="chartOptions?.labels" [responsive]="chartOptions?.responsive"></apx-chart>
                      </div>
                      <div *ngIf="noChart" style="height: 298px;">
                        <img class="empty-state" style="margin-top: 11%;" src="/assets/img/noData.png" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 p-1">
                  <div class="card  text-color-theme text-center h-100">
                    <div class="card-body p-10 m-3" style="padding: 30px">
                      <div class="mb-4">
                        <mat-button-toggle-group appearance="legacy" [(ngModel)]="selectedCurr"
                          #group="matButtonToggleGroup">
                          <mat-button-toggle value="EGP">
                            <span class="text-color-theme text-sm">{{'egp'|translate}}</span>
                          </mat-button-toggle>
                          <mat-button-toggle value="USD">
                            <span class="text-color-theme text-sm"> {{'usd'|translate}}</span>
                          </mat-button-toggle>
                          <mat-button-toggle value="Rated">
                            <span class="text-color-theme text-sm">{{'rated'|translate}}</span>
                          </mat-button-toggle>
                        </mat-button-toggle-group>
                      </div>
                      <div class="mb-4 d-flex justify-content-between" *ngIf="userPortfolio">
                        <h5 class="profile-heading m-0">{{"book-balance"|translate}}
                          <hint-popover [key]="'book-balance-hint'"></hint-popover>
                        </h5>
                        <span [ngClass]="{'green':(bookBalance?.
                        activebalance>0), 'red': (bookBalance?.
                        activebalance<0), '':bookBalance?.
                        activebalance==0}" style="font-size: 25px">
                          <!-- {{ratedBookBalance.bookbalance|number: "1.0":"en-US"}} -->
                          {{ bookBalance?.activebalance | number: "1.0":"en-US"}}
                          <!-- <span style="font-size: 16px;" class="text-muted">
                            {{selectedCurr | translate}}
                          </span> -->
                        </span>
                        <span style="font-size: 25px" *ngIf="!ratedBookBalance">
                          0
                        </span>
                      </div>
                      
                      <div class="mb-4 d-flex justify-content-between">
                        <h5 class="profile-heading m-0">
                          {{ "total-stocks-value" | translate }}
                          <hint-popover
                            [key]="'total-stock-value-hint'"
                          ></hint-popover>
                        </h5>

                        <span
                          style="font-size: 25px"
                          *ngIf="
                            currenciedPortfolio != null &&
                            currenciedPortfolio?.TotalMarketValue
                          "
                        >
                          {{
                            currenciedPortfolio?.TotalMarketValue
                              | number : "1.0" : "en-US"
                          }}
                        </span>
                        <span  style="font-size: 25px" *ngIf="currenciedPortfolio != null && !currenciedPortfolio?.TotalMarketValue">
                          0
                        </span>
                      </div>

                      <!-- TODO: new field TotalMarginMarketValue -->
                      <ng-container *ngIf="userPortfolio?.Profile.IsMargin">
                        <div class="mb-4 d-flex justify-content-between">
                          <h5 class="profile-heading m-0">
                            {{ "total-margin-mkt-value" | translate }}
                          </h5>
  
                          <span
                            style="font-size: 25px"
                            *ngIf="
                              currenciedPortfolio != null &&
                              currenciedPortfolio?.TotalMarginMarketValue
                            "
                          >
                            {{
                              currenciedPortfolio?.TotalMarginMarketValue
                                | number : "1.0" : "en-US"
                            }}
                          </span>
                          <span  style="font-size: 25px" *ngIf="currenciedPortfolio != null && !currenciedPortfolio?.TotalMarginMarketValue">
                            0
                          </span>
                        </div>
                      </ng-container>
                      <div class="mb-4 d-flex justify-content-between">
                        <h5 class="profile-heading m-0">{{"net-asset"|translate}}
                          <hint-popover [key]="'net-asset-hint'"></hint-popover>
                        </h5>
                        <span style="font-size: 25px" *ngIf="currenciedBookBalance">
                          {{ currenciedBookBalance?.netAsset |number: "1.0":"en-US"}}
                        </span>
                        <span style="font-size: 25px" *ngIf="!currenciedBookBalance">
                          0
                        </span>

                      </div>
                      <div class="mb-4 d-flex justify-content-between">
                        <h5 class="profile-heading m-0">{{'G/L'|translate}}</h5>
                        <span
                          [ngClass]="{'green':(currenciedPortfolio?.TotalGL>0), 'red': (currenciedPortfolio?.TotalGL<0), '':currenciedPortfolio?.TotalGL==0}"
                          style="font-size: 25px">
                          {{currenciedPortfolio?.TotalGL |number: "1.0":"en-US"}}

                          <span *ngIf="currenciedPortfolio?.TotalGLPer">
                            ({{currenciedPortfolio?.TotalGLPer | number: "1.2-2":"en-US" }} %)
                          </span>
                          <span *ngIf="!currenciedPortfolio?.TotalGLPer">
                            (0 %)
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="tab-pane fade " id="actions" role="tabpanel">
              <div class="wallet">
                <div class="row">
                  <div class="col-md-12 col-lg-2">
                    <div class="nav flex-column nav-pills" role="tablist" aria-orientation="vertical">
                      <a class="nav-link d-flex justify-content-between align-items-center active" data-toggle="pill"
                        href="#deposit" role="tab" aria-selected="true" (click)="resetForm()">
                        <div class="d-flex">
                          <div>
                            <h2>{{"deposit"|translate}}</h2>
                          </div>
                        </div>
                      </a>
                      <a class="nav-link d-flex justify-content-between align-items-center" data-toggle="pill"
                        href="#withdraw" role="tab" aria-selected="true" (click)="withdrawForm.reset()">
                        <div class="d-flex">
                          <div>
                            <h2>{{"withdraw"|translate}}</h2>
                          </div>
                        </div>
                      </a>
                      <a class="nav-link d-flex justify-content-between align-items-center" data-toggle="pill"
                        href="#requestStock" role="tab" aria-selected="true" (click)="reqStockForm.reset()">
                        <div class="d-flex">
                          <div>
                            <h2>{{"request-stock"|translate}}</h2>
                          </div>
                        </div>
                      </a>
                      <a class="nav-link d-flex justify-content-between align-items-center" data-toggle="pill"
                        href="#requestT0" role="tab" aria-selected="true">
                        <div class="d-flex">
                          <div>
                            <h2>{{"request-t0"|translate}}</h2>
                          </div>
                        </div>
                      </a>
                      <a class="nav-link d-flex justify-content-between align-items-center" data-toggle="pill"
                        href="#complains" role="tab" aria-selected="true" (click)="complainForm.reset()">
                        <div class="d-flex">
                          <div>
                            <h2>{{"complain"|translate}}</h2>
                          </div>
                        </div>
                      </a>
                      <a class="nav-link d-flex justify-content-between align-items-center" data-toggle="pill"
                        href="#suggestion" role="tab" aria-selected="true" (click)="suggestionForm.reset()">
                        <div class="d-flex">
                          <div>
                            <h2>{{"suggestion"|translate}}</h2>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="col-md-12 col-lg-10">
                    <div class="tab-content">
                      <div class="tab-pane fade show active" id="deposit" role="tabpanel">
                        <div class="card ">
                          <div class="card-body">
                            <h2 class="text-color-theme mb-4">{{"new-deposit"|translate}}</h2>

                            <div class="settings-profile">
                              <form #payableForm="ngForm" (ngSubmit)="submitDeposit(payableForm)">
                                <div class="form-row">
                                  <div class="col-md-6">
                                    <label class="required">{{"currency"|translate}}</label>
                                    <ng-select [searchable]="false" class="custom" #CurrencyId="ngModel" ngModel
                                      name="CurrencyId" required>
                                      <ng-option *ngFor=" let curr of currencyList" [value]="curr">
                                        {{translate.currentLang=='en'?curr.CurrencyNameE:curr.CurrencyNameA}}
                                      </ng-option>
                                    </ng-select>
                                  </div>
                                  <div class="col-md-6">
                                    <label class="required">{{"account"|translate}}</label>
                                    <ng-select name="RelationCode" #RelationCode="ngModel" class="custom" ngModel
                                      required>
                                      <ng-option *ngFor=" let acc of accList" value="{{acc.relationCode}}">
                                        ({{acc.relationCode}})
                                        {{translate.currentLang=='en'?acc.clientNameEn:acc.clientNameAr}}</ng-option>
                                    </ng-select>
                                    <div *ngIf="client.touched && client.invalid" class="red">
                                      <div *ngIf="client.errors.required">You must select client</div>
                                    </div>
                                  </div>

                                  <!-- <div class="col-md-6">
                                    <label class="required">{{"select-date"|translate}}</label>
                                    <div>
                                      <input [min]="today" (focus)="pickerDeposit.open()" class="form-control" #Date="ngModel" ngModel id="Date" matInput name="Date" [matDatepicker]="pickerDeposit" required>
                                      <mat-datepicker #pickerDeposit></mat-datepicker>
                                    </div>

                                  </div> -->

                                  <div class="col-md-6">
                                    <label class="required">{{"deposit-amount"|translate}}</label>
                                    <input name="Amount" #Amount="ngModel" ngModel name="Amount" type="text"
                                      class="form-control"
                                      [ngClass]="(translate.currentLang=='en')?'number-input': 'number-input-ar'"
                                      appTwoDigitDecimalNumber appInputCommaSepreated>
                                  </div>

                                  <div class="col-md-6">
                                    <label class="required">{{"deposit-bank"|translate}}</label>
                                    <ng-select name="DepositeBankId" #DepositeBankId="ngModel" class="custom" ngModel
                                      required>
                                      <ng-option *ngFor=" let bank of banksList" [value]="bank">
                                        {{(translate.currentLang=='en')?bank.BankNameE:bank.BankNameA}}</ng-option>
                                    </ng-select>
                                  </div>
                                </div>
                                <div class="row px-2 mt-2" style="justify-content: space-between;">
                                  <div class="form-field">
                                    <button type="button" class="credit-btn" (click)="file.click()">{{ 'upload' | translate
                                      }}<i class="fas fa-paperclip mx-2" aria-hidden="true"></i>
                                      <input hidden class="form-control" #file required ngModel type="file"
                                        accept=".pdf, .doc, docx, image/jpeg, image/jpg, image/png"
                                        (change)="importFile($event.target.files)" name="file" />
                                    </button>
                                    <span class="text-color-theme" *ngIf="fileName">{{fileName}}</span>
                                  </div>
                                  <button class="btn btn-primary" type="submit"
                                    [disabled]="payableForm.invalid || isSubmitting">
                                    <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm"></span>
                                    {{"send"|translate}}
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="tab-pane fade" id="withdraw" role="tabpanel">
                        <div class="card ">
                          <div class="card-body">
                            <h2 class="text-color-theme mb-4">{{"new-withdraw"|translate}}</h2>

                            <div class="settings-profile">
                              <form #withdrawForm="ngForm" (ngSubmit)="submitWithdraw(withdrawForm)">
                                <div class="form-row">
                                  <div class="col-md-6">
                                    <label class="required">{{"currency"|translate}}</label>
                                    <ng-select [searchable]="false" class="custom" #CurrencyId="ngModel" ngModel
                                      name="CurrencyId" required>
                                      <ng-option *ngFor=" let curr of currencyList" [value]="curr">
                                        {{translate.currentLang=='en'?curr.CurrencyNameE:curr.CurrencyNameA}}
                                      </ng-option>
                                    </ng-select>
                                  </div>
                                  <div class="col-md-6">
                                    <label class="required">{{"account"|translate}}</label>
                                    <ng-select name="client" #client="ngModel" class="custom"
                                      (change)="fetchPurchasePower(newWithdraw.RelationCode)"
                                      [(ngModel)]="newWithdraw.RelationCode" required>
                                      <ng-option *ngFor=" let acc of accList" value="{{acc.relationCode}}">
                                        ({{acc.relationCode}})
                                        {{translate.currentLang=='en'?acc.clientNameEn:acc.clientNameAr}}</ng-option>
                                    </ng-select>
                                  </div>

                                  <!-- <div class="col-md-6">
                                    <div class="row">
                                      <div class="col-md-12">
                                        <label class="required">{{'select-date'|translate}}</label>
                                        <div>
                                          <input [min]="today" (focus)="picker.open()" class="form-control" #date="ngModel" id="date" matInput name="withdrawDate" [(ngModel)]="newWithdraw.Date" [matDatepicker]="picker" required>
                                         <mat-datepicker #picker></mat-datepicker>
                                        </div>
                                      </div>
                                    </div>
                                  </div> -->
                                  <div class="col-md-6">
                                    <label class="required">{{"withdraw-amount"|translate}}</label>
                                    <input [(ngModel)]="newWithdraw.Amount" #Amount="ngModel" name="Amount" type="text"
                                      class="form-control"
                                      [ngClass]="(translate.currentLang=='en')?'number-input': 'number-input-ar'"
                                      required min="1" appTwoDigitDecimalNumber appInputCommaSepreated>
                                    <span *ngIf="availableWithdrawBalance != null"
                                      [ngClass]="{'green':availableWithdrawBalance > 0, 'red': availableWithdrawBalance < 0, 'grey': availableWithdrawBalance == 0}">{{'availb-bal'|translate}}
                                      :
                                      <strong *ngIf="availableWithdrawBalance % 1 != 0"> {{availableWithdrawBalance|
                                        number}}</strong>
                                      <strong *ngIf="availableWithdrawBalance % 1 == 0"> {{availableWithdrawBalance|
                                        number}}</strong>
                                    </span>
                                  </div>

                                  <div class="col-md-3 mb-2">
                                    <label class="required">{{"transaction-type"|translate}}</label>
                                    <br>

                                    <mat-radio-group color="primary" [(ngModel)]="newWithdraw.ActionType"
                                      #ActionType="ngModel" name="ActionType" required>
                                      <mat-radio-button class="mx-2" value=1>{{"check-deposit"|translate}}
                                      </mat-radio-button>
                                      <mat-radio-button class="mx-2" value=2 checked>{{"bank-transfer"|translate}}
                                      </mat-radio-button>
                                    </mat-radio-group>
                                  </div>
                                  <div class="col-md-6">
                                    <label>{{ "notes" | translate }}</label>
                                    <textarea
                                      [(ngModel)]="newWithdraw.Note"
                                      #Note="ngModel"
                                      name="Note"
                                      class="form-control notes-textarea"
                                      rows="1"
                                    ></textarea>
                                  </div>

                                  <div class="col-md-6"></div>

                                  <div *ngIf="newWithdraw.ActionType == 2" class="col-md-12">
                                    <div class="row">
                                      <div class="col-md-6">
                                        <label class="required">{{"deposit-bank"|translate}}</label>
                                        <ng-select [clearable]="false" name="depositBank" #depositBank="ngModel"
                                          class="custom" ngModel (change)="GetBranches($event)"
                                          [required]="newWithdraw.ActionType == 2">
                                          <ng-option *ngFor=" let bank of banksList" [value]="bank">
                                            {{(translate.currentLang=='en')?bank.BankNameE:bank.BankNameA}}</ng-option>
                                        </ng-select>
                                      </div>

                                      <div class="col-md-6">
                                        <label class="required">{{"bank-branch"|translate}}</label>
                                        <ng-select [clearable]="false" name="bankBranch" #bankBranch="ngModel"
                                          class="custom" ngModel [required]="newWithdraw.ActionType == 2">
                                          <ng-option *ngFor=" let branch of branches" [value]="branch">
                                            {{(translate.currentLang=='en')?branch.BankNameE:branch.BankNameA}}
                                          </ng-option>
                                        </ng-select>
                                      </div>

                                      <div class="col-md-6">
                                        <label class="required">{{"iban"|translate}}</label>
                                        <input [(ngModel)]="newWithdraw.SwiftCode" name="SwiftCode" #SwiftCode="ngModel"
                                          type="text" class="form-control" [maxlength]="29"
                                          placeholder="Enter IBAN Code" [required]="newWithdraw.ActionType == 2">
                                      </div>

                                      <div class="col-md-6">
                                        <label class="required">{{"account-number"|translate}}</label>
                                        <input [(ngModel)]="newWithdraw.AccountNumber" name="AccountNumber"
                                          #AccountNumber="ngModel" type="text" class="form-control"
                                          placeholder="Enter Account #" [required]="newWithdraw.ActionType == 2">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="row px-2 mt-2" style="justify-content: end;">
                                  <button class="btn btn-primary" type="submit"
                                    [disabled]="withdrawForm.invalid || newWithdraw.Amount>availableWithdrawBalance || isSubmitting">
                                    <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm"></span>
                                    {{"send"|translate}}
                                  </button>
                                </div>
                                <span class="info-warning">{{"withdraw-note"|translate}}</span>


                              </form>

                            </div>
                          </div>

                        </div>
                      </div>
                      <div class="tab-pane fade" id="requestStock" role="tabpanel">
                        <div class="card ">
                          <div class="card ">
                            <div class="card-body">
                              <h2 class="text-color-theme mb-4">{{"request-stock"|translate}}</h2>

                              <div class="settings-profile">
                                <form #reqStockForm="ngForm" (ngSubmit)="submitReqStock(reqStockForm)">
                                  <div class="form-row">
                                    <div class="col-md-6">
                                      <label class="required">{{"account"|translate}}</label>
                                      <ng-select name="RelationCode" #RelationCode="ngModel" class="custom" ngModel
                                        (change)="fetchSymbolsandCustd()" required>
                                        <!-- <ng-option *ngFor=" let acc of accList" value="{{acc.Profile?.RelationCode}}">
                                          ({{acc?.Profile?.RelationCode}})
                                          {{(translate.currentLang=="en")?acc.Profile?.SubNameE:acc.Profile?.SubNameA}}
                                        </ng-option> -->
                                        <ng-option *ngFor=" let acc of accList" value="{{acc.relationCode}}">
                                          ({{acc.relationCode}})
                                          {{translate.currentLang=='en'?acc.clientNameEn:acc.clientNameAr}}</ng-option>
                                      </ng-select>
                                    </div>
                                    <!-- <div class="col-md-6">
                                      <label class="required">{{"market"|translate}}</label>
                                      <ng-select [searchable]="false" class="custom" ngModel #market="ngModel" name="market">
                                        <ng-option *ngFor=" let curr of currencyList" value="{{curr.CurrencyID}}">
                                          {{translate.currentLang=='en'?curr.CurrencyNameE:curr.CurrencyNameA}}
                                        </ng-option>
                                      </ng-select>
                                    </div> -->
                                    <div class="col-md-6">
                                      <label class="required">{{"stock"|translate}}</label>
                                      <ng-select [searchable]="true" class="custom" ngModel #SymbolCode="ngModel"
                                        name="SymbolCode" required>
                                        <ng-option *ngFor=" let Symbol of allstocks" [value]="Symbol">
                                          ({{Symbol.ReutersCode}})
                                          {{(translate.currentLang=="en")?Symbol.ShortNameE:Symbol.ShortNameA}}
                                        </ng-option>
                                      </ng-select>
                                    </div>
                                    <div class="col-md-6">
                                      <label class="required">{{"custodian"|translate}}</label>
                                      <ng-select [searchable]="true" class="custom" ngModel #CustodianCode="ngModel"
                                        name="CustodianCode" required>
                                        <ng-option *ngFor=" let Custodian of allCustod" [value]="Custodian">
                                          ({{Custodian.CustodianCode}})
                                          {{(translate.currentLang=="en")?Custodian.CustodianNameE:Custodian.CustodianNameA}}
                                        </ng-option>
                                      </ng-select>
                                    </div>
                                    <div class="col-md-6">
                                      <label class="required">{{"qty"|translate}}</label>
                                      <input ngModel #Qty="ngModel" (keypress)="noDecimal($event)"
                                        oninput="if(!this.value.match('^[1-9][0-9]*$'))this.value='';" min="1"
                                        name="Qty" type="text" class="form-control" required appInputCommaSepreated>
                                    </div>
                                    <div class="col-md-6">
                                      <label class="required">{{"cost-price"|translate}}</label>
                                      <input class="form-control"
                                        [ngClass]="(translate.currentLang=='en')?'number-input': 'number-input-ar'"
                                        id="CostPrice" #CostPrice="ngModel" name="CostPrice" ngModel min="1" type="text"
                                        required [appTwoDigitDecimalNumber]='true' appInputCommaSepreated>
                                      <div *ngIf=" CostPrice.touched && CostPrice.invalid" class="red">
                                        <span *ngIf="CostPrice.errors.required">{{"amount-num-err"|translate}}</span>
                                        <span *ngIf="CostPrice.errors.pattern">{{"amount-decimal-err"|translate}}</span>
                                      </div>
                                    </div>
                                    <div class="col-md-6 d-flex justify-content-end">
                                      <button class="btn btn-primary align-self-center mt-4" type="submit"
                                        [disabled]="reqStockForm.invalid || isSubmitting">
                                        <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm"></span>
                                        {{"add-stock"|translate}}
                                      </button>
                                    </div>

                                  </div>




                                </form>

                              </div>
                            </div>

                          </div>
                        </div>

                      </div>
                      <div class="tab-pane fade" id="requestT0" role="tabpanel">
                        <div class="card ">
                          <div class="card-body">
                            <form #reqT0Form="ngForm" (ngSubmit)="submitReqT0(reqT0Form)">
                              <h2 class="text-color-theme mb-4">{{"request-t0" | translate}}</h2>
                              <div class="row mb-2">
                                <label class="col-md-2">{{"account"|translate}}</label>
                                <ng-select [searchable]="false" class="col-md-5 not custom" ngModel
                                  #RelationCode="ngModel" name="RelationCode" (change)="fetchDepartment()" required>
                                  <ng-option *ngFor=" let acc of accList" value="{{acc.relationCode}}">
                                    ({{acc.relationCode}})
                                    {{translate.currentLang=='en'?acc.clientNameEn:acc.clientNameAr}}
                                  </ng-option>
                                </ng-select>
                              </div>
                              <br>
                              <div class="row">
                                <label class="col-md-2"
                                  for="exampleFormControlTextarea1">{{"request-t0-hint"|translate}}</label>
                                <textarea [(ngModel)]="Endorsement" name="Body" class="form-control col-md-7 text-end"
                                  id="exampleFormControlTextarea1" rows="6" readonly></textarea>
                              </div>
                              <div class="row mt-3">
                                <div class="col-md-5 mx-auto">
                                  <input type="checkbox" ngModel #endorsementCheck="ngModel" name="endorsementCheck"
                                    id="endorsementCheck" required>
                                  <label class="px-2" for="flexCheckIndeterminate">
                                    {{'endorsement-check'| translate}}
                                  </label>
                                </div>
                              </div>

                              <div class="row px-md-5" style="justify-content: space-around;">
                                <button class="btn btn-primary button" type="submit"
                                  [disabled]="reqT0Form.invalid || isSubmitting">
                                  <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm"></span>
                                  {{"send"|translate}}
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div class="tab-pane fade" id="complains" role="tabpanel">
                        <div class="card ">
                          <div class="card-body">
                            <form #complainForm="ngForm" (ngSubmit)="submitComplain(complainForm,true)">
                              <h2 class="text-color-theme mb-4">{{"new-complain" | translate}}</h2>
                              <div class="form-group">
                                <label for="exampleFormControlTextarea1">{{"complain-hint"|translate}}</label>
                                <textarea ngModel #Body="ngModel" name="Body" class="form-control"
                                  id="exampleFormControlTextarea1" rows="3" required></textarea>
                              </div>
                              <div class="row px-2 mt-2" style="justify-content: space-between;">
                                <div class="col-md-6">
                                  <label>{{"complain-drplist"|translate}}</label>
                                  <ng-select [searchable]="false" class="custom" ngModel #DepartmentId="ngModel"
                                    name="DepartmentId" required>
                                    <ng-option *ngFor=" let dept of deptList" [value]="dept">
                                      {{translate.currentLang=='en'?dept.DepartmentNameE:dept.DepartmentNameA}}
                                    </ng-option>
                                  </ng-select>
                                </div>
                                <button class="btn btn-primary button" type="submit"
                                  [disabled]="complainForm.invalid || isSubmitting">
                                  <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm"></span>
                                  {{"send"|translate}}
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div class="tab-pane fade" id="suggestion" role="tabpanel">
                        <div class="card ">
                          <div class="card-body">
                            <form #suggestionForm="ngForm" (ngSubmit)="submitComplain(suggestionForm,false)">
                              <h2 class="text-color-theme mb-4">{{"new-suggestion"|translate}}</h2>
                              <div class="form-group">
                                <label for="exampleFormControlTextarea1">{{'suggestion-hint'|translate}}</label>
                                <textarea ngModel #Body="ngModel" name="Body" class="form-control"
                                  id="exampleFormControlTextarea1" rows="3" required></textarea>
                              </div>
                              <div class="row px-2 mt-2" style="justify-content: end;">
                                <button class="btn btn-primary" type="submit"
                                  [disabled]="suggestionForm.invalid || isSubmitting">
                                  <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm"></span>
                                  {{"send"|translate}}
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="transfers" role="tabpanel">
              <div class="wallet">
                <div class="row">
                  <div class="col-md-12 col-lg-2">
                    <div class="nav flex-column nav-pills" role="tablist" aria-orientation="vertical">
                      <a class="nav-link d-flex justify-content-between align-items-center active" data-toggle="pill"
                        href="#CashTransfer" role="tab" aria-selected="true" (click)="cashTransactionForm.reset()">
                        <div class="d-flex">
                          <div>
                            <h2> {{"cash-transfer"|translate}}</h2>
                          </div>
                        </div>
                      </a>
                      <a class="nav-link d-flex justify-content-between align-items-center" data-toggle="pill"
                        href="#StockTransfer" role="tab" aria-selected="true" (click)="stockTransactionForm.reset()">
                        <div class="d-flex">
                          <div>
                            <h2> {{"stock-transfer"|translate}}</h2>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="col-md-12 col-lg-10">
                    <div class="tab-content">
                      <div class="tab-pane fade show active" id="CashTransfer" role="tabpanel">
                        <div class="card">
                          <div class="card-body">
                            <h2 class="text-color-theme mb-4">{{"new-cash-transfer"|translate}}</h2>

                            <div class="settings-profile">
                              <form #cashTransactionForm="ngForm">
                                <div class="form-row">
                                  <div class="col-md-6">
                                    <label class="required">{{"from-account"|translate}}</label>
                                    <select id="FromAccount" #FromAccount="ngModel"
                                      (change)="fetchPurchasePower(newCashTransfer.FromRelationCode)"
                                      [(ngModel)]="newCashTransfer.FromRelationCode" name="FromAccount"
                                      (change)="accountListValidation($event.target.value)" class="custom-select px-4"
                                      required>
                                      <option *ngFor=" let acc of fromAccList" value="{{acc?.relationCode}}">
                                        ({{acc.relationCode}})             
                                      <span *ngIf="translate.currentLang === 'en'">
                                        {{ acc.clientNameEn }} — {{ acc.accountTypeEn }}
                                      </span>
                                      <span *ngIf="translate.currentLang === 'ar'" dir="rtl" style="display:flex; justify-content:space-between; width:100%">
                                        <span>{{ acc.clientNameAr }} — </span>
                                        <span>{{ acc.accountTypeAr }}</span>
                                      </span>
                                      </option>
                                    </select>
                                    <div *ngIf="FromAccount.touched && FromAccount.invalid" class="red">
                                      <div *ngIf="FromAccount.errors.required">{{"acc-stock-err"|translate}}</div>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <label class="required">{{"to-account"|translate}}</label>
                                    <select id="ToAccount" name="ToAccount" #ToAccount="ngModel" class="custom-select px-4"
                                      [(ngModel)]="newCashTransfer.ToRelationCode" required>
                                      <option *ngFor=" let acc of toAccList" value="{{acc?.relationCode}}">
                                        ({{acc.relationCode}})             
                                        <span *ngIf="translate.currentLang === 'en'">
                                          {{ acc.clientNameEn }} — {{ acc.accountTypeEn }}
                                        </span>
                                        <span *ngIf="translate.currentLang === 'ar'" dir="rtl" style="display:flex; justify-content:space-between; width:100%">
                                          <span>{{ acc.clientNameAr }} — </span>
                                          <span>{{ acc.accountTypeAr }}</span>
                                        </span>
                                      </option>
                                    </select>
                                    <div *ngIf="ToAccount.touched && ToAccount.invalid" class="red">
                                      <div *ngIf="ToAccount.errors.required">{{"acc-stock-err"|translate}}</div>
                                    </div>
                                  </div>

                                  <div class="col-md-6">
                                    <div class="row">
                                      <div class="col-md-12">
                                        <label class="required">{{"currency"|translate}}</label>
                                        <ng-select id="Currency" name="Currency" #Currency="ngModel"  
                                          (change)="fetchPurchasePower(newCashTransfer.FromRelationCode)" class="custom"
                                          ngModel required>
                                          <ng-option *ngFor=" let curr of currencyList" [value]="curr">
                                            {{(translate.currentLang=="en")?curr.CurrencyNameE:curr.CurrencyNameA}}
                                          </ng-option>
                                        </ng-select>
                                        <div *ngIf="Currency.touched && Currency.invalid" class="red">
                                          <div *ngIf="Currency.errors.required">{{"currency-err"|translate}}</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <div class="row">
                                      <div class="col-md-12">
                                        <label class="required">{{"amount"|translate}}</label>
                                        <div>
                                          <input class="form-control"
                                            [ngClass]="(translate.currentLang=='en')?'number-input': 'number-input-ar'"
                                            type="text" ngModel #Amount="ngModel" id="Amount" name="Amount"
                                            [(ngModel)]="newCashTransfer.Amount" number min="1" appTwoDigitDecimalNumber
                                            appInputCommaSepreated required>
                                        </div>

                                        <span *ngIf="balanceAmount"
                                          [ngClass]="{'green':availableTransferBalance(cashTransactionForm) > 0, 'red': availableTransferBalance(cashTransactionForm)  < 0, 'grey': availableTransferBalance(cashTransactionForm)  == 0}">
                                          {{'availb-bal-transfer'|translate}} :
                                          {{availableTransferBalance(cashTransactionForm) | number}}
                                        </span>
                                        <div *ngIf="Amount.touched && Amount.invalid" class="red">
                                          <span *ngIf="Amount.errors.required">{{"amount-num-err"|translate}}</span>
                                          <span *ngIf="Amount.errors.pattern">{{"amount-decimal-err"|translate}}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                </div>
                                <div class="row px-2 mt-2" style="justify-content: start;">
                                  <button class="btn btn-primary" type="submit"
                                    [disabled]="cashTransactionForm?.invalid || isSubmitting || newCashTransfer.Amount> availableTransferBalance(cashTransactionForm)"
                                    (click)="submitCashTransfer(cashTransactionForm)">
                                    <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm"></span>
                                    {{"transfer"|translate}}
                                  </button>
                                  <button class="btn btn-primary" (click)="onReset(cashTransactionForm)">
                                    {{"clear"|translate}}
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="tab-pane fade" id="StockTransfer" role="tabpanel">
                        <div class="card ">
                          <div class="card-body">
                            <h2 class="text-color-theme mb-4"> {{"new-stock-transfer"|translate}}</h2>

                            <div class="settings-profile">
                              <form #stockTransactionForm="ngForm">
                                <div class="form-row">
                                  <div class="col-md-6">
                                    <label class="required">{{"from-account"|translate}}</label>
                                    <select id="FromAccountStock" #FromAccountStock="ngModel"
                                      [(ngModel)]="newStockTransfer.FromRelationCode"
                                      (change)="accountStockListValidation($event.target.value)" name="FromAccountStock"
                                      class="custom-select px-4" required>
                                    <option *ngFor="let acc of filteredAccounts" [value]="acc.relationCode">
                                        ({{acc.relationCode}})             
                                         <span *ngIf="translate.currentLang === 'en'">
                                        {{ acc.clientNameEn }} — {{ acc.accountTypeEn }}
                                      </span>
                                      <span *ngIf="translate.currentLang === 'ar'" dir="rtl" style="display:flex; justify-content:space-between; width:100%">
                                        <span>{{ acc.clientNameAr }} — </span>
                                        <span>{{ acc.accountTypeAr }}</span>
                                      </span>
                                      </option>
                                    </select>
                                    <div *ngIf="FromAccountStock.touched && FromAccountStock.invalid" class="red">
                                      <div *ngIf="FromAccountStock.errors.required">{{"acc-stock-err"|translate}}</div>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <label class="required"> {{"to-account"|translate}}</label>
                                    <select id="ToRelationCode" name="ToRelationCode" #ToRelationCode="ngModel"
                                      class="custom-select px-4" [(ngModel)]="newStockTransfer.ToRelationCode" required>
                                      <option *ngFor=" let acc of toStockAccList" value="{{acc?.relationCode}}">
                                       ({{acc.relationCode}})             
                                       <span *ngIf="translate.currentLang === 'en'">
                                        {{ acc.clientNameEn }} — {{ acc.accountTypeEn }}
                                      </span>
                                      <span *ngIf="translate.currentLang === 'ar'" dir="rtl" style="display:flex; justify-content:space-between; width:100%">
                                        <span>{{ acc.clientNameAr }} — </span>
                                        <span>{{ acc.accountTypeAr }}</span>
                                      </span>
                                      </option>
                                    </select>
                                    <div *ngIf="ToRelationCode.touched && ToRelationCode.invalid" class="red">
                                      <div *ngIf="ToRelationCode.errors.required"> {{"acc-stock-err"|translate}}</div>
                                    </div>
                                  </div>

                                  <div class="col-md-6">
                                    <div class="row">
                                      <div class="col-md-12">
                                        <label class="required">{{"stock"|translate}}</label>
                                        <ng-select id="SymbolCode" (change)="stockTransferChanged($event)"
                                          [(ngModel)]="newStockTransfer.Symbol" name="SymbolCode" class="custom"
                                          required>
                                          <ng-option *ngFor=" let Symbol of stocksSymbolList" [value]="Symbol">
                                            <span class="d-flex justify-content-between">
                                              <div>
                                                {{(translate.currentLang=="en")?Symbol.SymbolNameEn:Symbol.SymbolNameAr}}
                                              </div>
                                              <div>{{"qty"|translate}}: {{Symbol.SetteledQty | number}}</div>
                                            </span>
                                            <small class="text-color-theme">
                                              {{"custodian"|translate}}:
                                              {{(translate.currentLang=="en")?Symbol.CustodianNameE:Symbol.CustodianNameA}}
                                            </small>
                                          </ng-option>
                                        </ng-select>
                                        <div *ngIf="SymbolCode.touched && SymbolCode.invalid" class="red">
                                          <div *ngIf="SymbolCode.errors.required">{{"stock-err"|translate}}</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- <div class="col-md-6">
                                    <div class="row">
                                      <div class="col-md-12">
                                        <label class="required">{{"custodian"|translate}}</label>
                                        <ng-select id="CustodianCode" [disabled]="!newStockTransfer.SymbolCode" name="CustodianCode" #CustodianCode="ngModel" class="custom" [(ngModel)]="newStockTransfer.CustodianCode" required>
                                          <ng-option *ngFor=" let Custodian of stocksCustodiansList" [value]="Custodian">
                                            ({{Custodian.CustodianCode}})
                                            {{(translate.currentLang=="en")?Custodian.CustodianNameE:Custodian.CustodianNameA}}
                                          </ng-option>
                                        </ng-select>
                                        <div *ngIf="CustodianCode.touched && CustodianCode.invalid" class="red">
                                          <div *ngIf="CustodianCode.errors.required">{{"custodian-err"|translate}}</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div> -->

                                  <div class="col-md-6">
                                    <div class="row">
                                      <div class="col-md-12">
                                        <label class="required">{{"quantity"|translate}}</label>
                                        <div>
                                          <!-- <input class="form-control" id="Qty" #Qty="ngModel" name="Quantity" [(ngModel)]="newStockTransfer.Qty" min="1" type="text" oninput="if(!this.value.match('^[1-9][0-9]*$'))this.value='';" (keypress)="noDecimal($event)" required (focusout)="commaSeprated($event)"> -->
                                          <input class="form-control" id="Qty" #Qty="ngModel" name="Quantity"
                                            [(ngModel)]="newStockTransfer.Qty" min="1" type="text"
                                            oninput="if(!this.value.match('^[1-9][0-9]*$'))this.value='';"
                                            appInputCommaSepreated required>

                                        </div>
                                        <div *ngIf="Qty.touched && Qty.invalid" class="red">
                                          <span *ngIf="Qty.errors.required">{{"amount-num-err"|translate}}</span>
                                          <span *ngIf="Qty.errors.pattern">{{"amount-decimal-err"|translate}}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <button class="btn btn-primary" type="submit"
                                  (click)="submitStockTransfer(stockTransactionForm)"
                                  [disabled]="stockTransactionForm.invalid || isSubmitting">
                                  <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm"></span>
                                  {{"transfer"|translate}}
                                </button>
                                <button class="btn btn-primary" (click)="stockTransactionForm.resetForm()">
                                  {{"clear"|translate}}
                                </button>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade show active  mt-xl-auto mt-lg-auto mt-3" id="portfolio" role="tabpanel" #portfolioSection
              aria-labelledby="portfolio-tab">
              <app-account-header (accChange)="fetchUserPortfolio($event)" [accList]="accList"
                [selectedAccount]="selectedAccount"></app-account-header>
              <div class="card settings-profile">
                <div class="card-body">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex justify-content-between">
                      <h4 class="text-color-theme mb-4">{{'cash-position'|translate}}</h4>

                      <button class="btn btn-sm btn-primary mx-2" placement='bottom'
                        ngbTooltip='{{"margin-calculator"|translate}}' *ngIf="userPortfolio?.Profile.IsMargin"
                        style="align-self: start;border-radius: 61%;padding:5px;" (click)=" marginCalculator()">
                        <mat-icon style="vertical-align: middle;">calculate</mat-icon>
                      </button>
                    </div>
                    <div>
                      <mat-button-toggle-group appearance="legacy" [(ngModel)]="selectedCurr"
                        #group="matButtonToggleGroup">
                        <mat-button-toggle value="EGP">
                          <span class="text-color-theme text-sm">{{'egp'|translate}}</span>
                        </mat-button-toggle>
                        <mat-button-toggle value="USD">
                          <span class="text-color-theme text-sm"> {{'usd'|translate}}</span>
                        </mat-button-toggle>
                        <mat-button-toggle value="Rated">
                          <span class="text-color-theme text-sm">{{'rated'|translate}}</span>
                        </mat-button-toggle>
                      </mat-button-toggle-group>
                    </div>
                  </div>
                  <br>
                  <div class="row settings-notification" *ngIf="userPortfolio">

                    <div [ngClass]="userPortfolio?.Profile.IsMargin || isMarginCust==2?'col-xl-2 col-md-3':'col-md-3'"
                      class="text-color-theme">
                      <div class="mb-3">
                        <h6>{{"book-balance"|translate}}
                          <hint-popover [key]="'book-balance-hint'"></hint-popover>
                        </h6>
                        <h4 [ngClass]="{'green':(bookBalance?.
                        activebalance>0), 'red': (bookBalance?.
                        activebalance<0), '':bookBalance?.
                        activebalance==0}">
                          {{ bookBalance?.
                          activebalance| number: "1.0":"en-US"}}
                          <span style="font-size: 16px;" class="text-muted">
                            {{selectedCurr | translate}}
                          </span>
                        </h4>
                      </div>
                    </div>
                    <div [ngClass]="userPortfolio?.Profile.IsMargin?'col-xl-2 col-md-2':'col-xl-2 col-md-2'" *ngIf="isMarginCust==2"
                      class="text-color-theme">
                      <h6>{{'bank-balance'|translate}}
                        <hint-popover [key]="'bank-balance-hint'"></hint-popover>
                      </h6>
                      <h4>
                        {{currenciedBookBalance?.MarginCustodian || 0}}
                        <span style="font-size: 16px;" class="text-muted">
                          {{selectedCurr | translate}}
                        </span>
                      </h4>
                    </div>
                    <div [ngClass]="userPortfolio?.Profile.IsMargin && isMarginCust==2?'col-xl-2 col-md-2':userPortfolio?.Profile.IsMargin || isMarginCust==2?'col-xl-2 col-md-3':'col-md-3'"
                      class="text-color-theme">
                      <div class="mb-3">
                        <h6>{{"block-amount"|translate}}
                          <hint-popover [key]="'block-amm-hint'"></hint-popover>
                        </h6>
                        <h4>
                          {{blockAmount| number: "1.0":"en-US"}}
                          <span style="font-size: 16px;" class="text-muted">
                            {{selectedCurr | translate}}
                          </span>
                        </h4>
                      </div>
                    </div>
                    <app-purchase-power-details *ngIf="ppDetailsShown" (dismiss)="ppDetailsShown=false"
                      [purchasePower]="userPortfolio?.PurchasePower?.purchasePower[selectedCurr]"
                      [blockingAmount]="userPortfolio?.PurchasePower?.BlockingAmount"
                      [currencySelection]="selectedCurr">
                    </app-purchase-power-details>
                    <div [ngClass]="userPortfolio?.Profile.IsMargin && isMarginCust==2?'col-xl-2 col-md-3':userPortfolio?.Profile.IsMargin || isMarginCust==2?'col-xl-2 col-md-3':'col-md-3'"
                      class="text-color-theme">
                      <div class="mb-3">
                        <h6>{{'purchase-power'|translate}}
                          <hint-popover [key]="'purchase-power-hint'"></hint-popover>
                          <button class="btn shadow-none" style="display: inline-flex;padding: 0px;"
                            (click)="ppDetailsShown = !ppDetailsShown">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white"
                              class="bi bi-file-earmark-text pdf-icon" viewBox="0 0 16 16">
                              <path
                                d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z" />
                              <path
                                d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                            </svg>
                          </button>
                        </h6>
                        <button class="btn shadow-none text-color-theme" style="display: inline-flex;padding: 0px;">
                          <h4 (click)="ppDetailsShown = !ppDetailsShown">
                            {{currenciedPP | number: "1.0":"en-US"}}
                            <span style="font-size: 16px;" class="text-muted">
                              {{selectedCurr | translate}}
                            </span>
                          </h4>
                        </button>
                      </div>
                    </div>
                    <div [ngClass]="userPortfolio?.Profile.IsMargin && isMarginCust==2?'col-xl-2 col-md-2':userPortfolio?.Profile.IsMargin || isMarginCust==2?'col-xl-2 col-md-3':'col-md-3'"
                      class="text-color-theme">
                      <div class="mb-3">
                        <h6>{{"net-asset"|translate}}
                          <hint-popover [key]="'net-asset-hint'"></hint-popover>
                        </h6>
                        <h4>
                          {{(currenciedBookBalance?.netAsset || 0) | number: "1.0":"en-US"}}
                          <span style="font-size: 16px;" class="text-muted">
                            {{selectedCurr | translate}}
                          </span>
                        </h4>
                      </div>
                    </div>
                    <div [ngClass]="userPortfolio?.Profile.IsMargin && isMarginCust==2?'col-xl-2 col-md-2':'col-xl-2 col-md-3'"
                      class="text-color-theme" *ngIf="userPortfolio?.Profile.IsMargin">
                      <h6>{{'margin-percentage'|translate}}
                        <hint-popover [key]="'margin-hint'"></hint-popover>
                      </h6>
                      <div class='row align-items-center' (click)=" marginCalculator()">
                        <circle-progress class="mx-1"
                          [percent]="userPortfolio?.PurchasePower.MarginPosition.UsedMarginPersentage" [radius]="12"
                          [space]="-3" [showSubtitle]="false" [showTitle]="false" [showUnits]="false"
                          [titleFontSize]="15" [titleColor]="isDarkTheme?'#ffffff':'black'" [unitsFontSize]="12" [unitsColor]="'#A9A9A9'"
                          [outerStrokeWidth]="3" [innerStrokeWidth]="3" [outerStrokeColor]="chartColor"
                          [outerStrokeGradientStopColor]="'#53a9ff'" [innerStrokeColor]="'#e7e8ea'" [animation]="false"
                          [outerStrokeGradient]="false">
                        </circle-progress>
                        <h4 class="m-0 mx-1">{{userPortfolio?.PurchasePower.MarginPosition.UsedMarginPersentage |
                          number: "1.2-2":"en-US"}} %</h4>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="card settings-profile">
                <div style="height: fit-content;">
                  <app-user-portfolio
                    *ngIf="selectedAccountType !== 6"
                    [userPortfolio]="currenciedPortfolio"
                    [acc]="selectedAccount">
                  </app-user-portfolio>
                  <app-user-portfolio-savings
                    *ngIf="selectedAccountType === 6"
                    [acc]="selectedAccount"
                    [inputPortfolio]="GoalCurrenciedPortfolio"
                    [currency]="selectedCurr"
                  ></app-user-portfolio-savings>

                </div>
              </div>

              <div class="card settings-profile">
                <div style="height: 400px;">
                  <app-order-book
                  [isFromProfile]="true" 
                  [acc]="selectedAccount" [isHeaderRowElementsLayout]="true" ></app-order-book>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
<ngx-loading [show]="isProfileLoading" [config]="{ backdropBorderRadius: '14px' }"></ngx-loading>